import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { AbstractSecurityStorage, provideAuth } from 'angular-auth-oidc-client';
import { authConfig, MyStorageService } from './pages/auth/auth.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService } from 'primeng/api';
import { authIdInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAuth(authConfig),
    provideHttpClient(withInterceptors([authIdInterceptor])),
    provideAnimations(),
    {provide: AbstractSecurityStorage, useClass: MyStorageService},
    provideAnimationsAsync(),
    MessageService,
    importProvidersFrom([BrowserAnimationsModule]),

  ]
};
